import { BrowserRouter } from "react-router-dom";
import "../src/styles/font.module.scss";
import "./App.css";
import "./i18n/i18n";
import AppRoutes from "./routes/AppRoutes";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import { initGA } from "./analytics";
import PageTitleManager from "./components/PageTitleManager";

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
      <HelmetProvider>
        <BrowserRouter>
          <PageTitleManager />
          <AppRoutes />
        </BrowserRouter>
      </HelmetProvider>
  );
}



export default App;
